<template lang="pug">
    include DashboardCecs.pug
</template>

<script>
import _ from "underscore"
import Api from "@/components/services/Api"
import CecsMixin from "@/mixins/CecsMixin"

export default {
  name: 'DashboardCecs',
  mixins: [CecsMixin],
  computed: {
    validNew() {
      console.log(this.entity.level_course)
      console.log(this.entity.type)
      if (!this.entity.level_course) return false;
      if (!this.entity.type) return false;
      return true;
    }
  },
  data() {
    return {
      showNewForm: false,
      seed: null,
      user: null,
      cecs: [],
      entity: {
        description: "",
        category: null,
        subcategory: null,
        level_course: null,
        type: null,
      },
      cecsData: [],
      categoriesData: [],
      subcategoriesData: [],
      uploadUrl: null,
      types: [
        {"id": "presencial", "name": "Presencial"},
        {"id": "semipresencial", "name": "Semipresencial"},
        {"id": "online", "name": "Online"},
        {"id": "a_distancia", "name": "A distancia"},
        {"id": "ninguna", "name": "Ninguna"},
      ]
    }
  },
  mounted() {
    this.$upload.reset('new-certificate', {
      url: this.uploadUrl,
    });
  },
  beforeDestroy() {
    this.$upload.reset('new-certificate', {
    });
  },
  created() {
    const _this = this
    this.seed = this.$uuid.v4()
    let apiBase = Api.getApiUrl()
    this.uploadUrl = `${apiBase}/esreps/cec-link-update/?seed=${this.seed}&token=${this.$store.state.token}`

    this.$upload.new('new-certificate', {
      async: true,
      multiple: false,
    })

    this.fetchFormData((err, result) => {
      if (!err) {
        _this.categoriesData = result.categories;
        _this.subcategoriesData = result.subcategories;
        _this.cecsData = result.cecs;
      }
    })

    Api.me(this.$store.state.token).then(response => {
      _this.user = response.data;
      _this.cecs = response.data.cecs;
    }).catch(err => {
    })
  },
  methods: {
    remove(item) {
      console.log("removing item: ", item)
    },
    formData() {
      return _.pick(this.entity, ...["level_course", "description", "type"])
    },
    saveNew() {
      Api.updateCecLink(this.formData(), this.seed, this.$store.state.token).then(resp => {
        window.location.reload()
      }).catch(err => {
      })
    }
  }
}

</script>

<style scoped lang="scss">
@import "./../../styles/common_forms";
@import "DashboardCecs";
</style>



// WEBPACK FOOTER //
// src/components/dashboard_cecs/DashboardCecs.vue